var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#clip0_2209_102183)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.29998 4.16663H6.63331C6.19128 4.16663 5.76736 4.34222 5.4548 4.65478C5.14224 4.96734 4.96664 5.39127 4.96664 5.83329V15.8333C4.96664 16.2753 5.14224 16.6992 5.4548 17.0118C5.76736 17.3244 6.19128 17.5 6.63331 17.5H14.9666C15.4087 17.5 15.8326 17.3244 16.1452 17.0118C16.4577 16.6992 16.6333 16.2753 16.6333 15.8333V5.83329C16.6333 5.39127 16.4577 4.96734 16.1452 4.65478C15.8326 4.34222 15.4087 4.16663 14.9666 4.16663H13.3",
    stroke: "#002244",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.29999 4.16667C8.29999 3.72464 8.47558 3.30072 8.78814 2.98816C9.1007 2.67559 9.52463 2.5 9.96665 2.5H11.6333C12.0753 2.5 12.4993 2.67559 12.8118 2.98816C13.1244 3.30072 13.3 3.72464 13.3 4.16667C13.3 4.60869 13.1244 5.03262 12.8118 5.34518C12.4993 5.65774 12.0753 5.83333 11.6333 5.83333H9.96665C9.52463 5.83333 9.1007 5.65774 8.78814 5.34518C8.47558 5.03262 8.29999 4.60869 8.29999 4.16667Z",
    stroke: "#002244",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2209_102183"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.799988)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgCalendar);
export default __webpack_public_path__ + "static/media/svg_calendar.9bcc2d4c42b00840f2bdf171fc6a70df.svg";
export { ForwardRef as ReactComponent };